import { commonEnvironment } from "./environment.common";

export const environment = {
    common: commonEnvironment,
    debug: false,
    labels: {
        "common": "labels.yml",
        "providerdna": "label-provider.yml",
        "dentemax": "label-dmxclient.yml",
        "bcbstx": "label-empbrk-common.yml,label-empbrk-tx.yml",
        "bcbsok.com": "label-empbrk-common.yml,label-empbrk-ok.yml",
        "bcbsnm.com": "label-empbrk-common.yml,label-empbrk-nm.yml",
        "bcbsmt.com": "label-empbrk-common.yml,label-empbrk-mt.yml",
        "bcbsil.com": "label-empbrk-common.yml,label-empbrk-il.yml",
        "mydearborngroup.com": "label-empbrk-common.yml,label-empbrk-dg.yml",
    },
    themes: { 
        "providerdna.com": 'assets/css/providerdna.min.css?v=1.0.0',
        "dentemax.com": "assets/css/dentemax.min.css?v=1.0.0",
        "bcbstx.com": "assets/css/empbrk.min.css?v=1.0.0",
        "bcbsok.com": "assets/css/empbrk.min.css?v=1.0.0", 
        "bcbsnm.com": "assets/css/empbrk.min.css?v=1.0.0",
        "bcbsmt.com": "assets/css/empbrk.min.css?v=1.0.0",
        "bcbsil.com": "assets/css/empbrk.min.css?v=1.0.0",
        "mydearborngroup.com": "assets/css/empbrk.min.css?v=1.0.0",
    },
    states: {    
        "bcbstx.com": "TX",
        "bcbsok.com": "OK",  
        "bcbsnm.com": "NM",
        "bcbsmt.com": "MT",
        "bcbsil.com": "IL",
        "mydearborngroup.com": "DG",
    },
};
